export const getMenu = state => state.menu.data;
